export default __webpack_public_path__ + "static/media/upButtonHover.5a8c35bc.svg";